/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import CitrixModel from './CitrixModel';
import RdpModel, { SERVERTYPE } from './RdpModel';
import VmwareViewModel from './VmwareViewModel';
import { REMOTE_DESKTOP_TYPE } from './VdiModel';

type RemoteDesktopModel = CitrixModel | RdpModel | VmwareViewModel;

function isVdiResourceList(resource: RemoteDesktopModel): boolean {
    return (
        typeof resource.parent === 'undefined' &&
        (resource.rdType === REMOTE_DESKTOP_TYPE.CITRIX ||
            resource.rdType === REMOTE_DESKTOP_TYPE.VMWARE_VIEW ||
            (resource.rdType === REMOTE_DESKTOP_TYPE.RDP && resource.serverType === SERVERTYPE.WEB_ACCESS))
    );
}

export {
    RemoteDesktopModel as default,
    RemoteDesktopModel,
    CitrixModel,
    RdpModel,
    VmwareViewModel,
    isVdiResourceList,
    REMOTE_DESKTOP_TYPE,
    SERVERTYPE,
};
